export default __webpack_public_path__ + "static/media/wife4.efcdfabb.png";